export default {
  namespaced: true,
  state: {
    // 销售
    sale: [],
    // 是否显示图表详情
    visible: false,
    // 活跃客户数据
    activeAccount: [],
    // 新增用户数据
    newAccount: [],
    // 新增产品数据
    newProduct: [],
    // 类型
    type: '',
  },
  getters: {},
  actions: {
    // 更新销售和团队
    updateSale({ commit }, payload) {
      commit('updateSale', payload);
    },

    // 显示/隐藏 图表详情
    updateVisible({ commit }, payload) {
      commit('updateVisible', payload);
    },

    // 更新活跃用户数据
    updateActiveAccount({ commit }, payload) {
      commit('updateActiveAccount', payload);
    },

    // 更新新增用户数据
    updateNewAccount({ commit }, payload) {
      commit('updateNewAccount', payload);
    },

    // 更新新增产品数据
    updateNewProduct({ commit }, payload) {
      commit('updateNewProduct', payload);
    },

    // 更新类型
    updateType({ commit }, payload) {
      commit('updateType', payload);
    },
  },
  mutations: {
    // 更新销售和团队
    updateSale(state, payload) {
      state.sale = payload;
    },

    // 显示/隐藏 图表详情
    updateVisible(state, payload) {
      state.visible = payload;
    },

    // 更新活跃用户数据
    updateActiveAccount(state, payload) {
      state.activeAccount = payload;
    },

    // 更新新增用户数据
    updateNewAccount(state, payload) {
      state.newAccount = payload;
    },

    // 更新新增产品数据
    updateNewProduct(state, payload) {
      state.newProduct = payload;
    },

    // 更新类型
    updateType(state, payload) {
      state.type = payload;
    },
  },
};
